import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import hubDaive from './assets/hubdaive.png';
import MenuLateral from './components/MenuLateral.jsx';
import MenuProfile from './components/MenuProfile.jsx';
import GoogleButton from 'react-google-button'

function Drive(){
    const navigate = useNavigate();
    const [files, setFiles] = useState([]);
    const [connected, setConnected] = useState(false);
    const [loading, setLoading] = useState(false);

    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState(null);
    const [searching, setSearching] = useState(false);

    const params = new URLSearchParams(window.location.search);
    const driveToken = params.get('drive_token');
    const refreshToken = params.get('refresh_token');
    
    if (driveToken) {
        localStorage.setItem('drive_token', driveToken);
        if (refreshToken) localStorage.setItem('drive_refresh_token', refreshToken);
        window.history.replaceState({}, '', '/drive');
    }

    const handleSearch = async () => {
        if (!searchQuery.trim()) return;
        const token = localStorage.getItem('drive_token');
        setSearching(true);
        
        const response = await fetch("https://hubdaive.com.br/api/drive/search", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token, query: searchQuery })
        });

        if (response.status === 401) {
            localStorage.removeItem('drive_token');
            localStorage.removeItem('drive_refresh_token');
            setConnected(false);
            return;
        }
        
        const data = await response.json();
        setSearchResults(data.files);
        setSearching(false);
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const driveToken = params.get('drive_token');
        if (driveToken) {
            localStorage.setItem('drive_token', driveToken);
            window.history.replaceState({}, '', '/drive');
            setConnected(true);
            fetchFiles(driveToken);
            return;
        }

        const token = localStorage.getItem('drive_token');
        if (token) {
            setLoading(true);
            setConnected(true);
            fetchFiles(token);
        }
    }, []);

    const fetchFiles = async (token) => {
        setLoading(true);
        const response = await fetch(`https://hubdaive.com.br/api/drive/files?token=${token}`);
        if (response.status === 401) {
            localStorage.removeItem('drive_token');
            localStorage.removeItem('drive_refresh_token');
            setConnected(false);
            return;
        }
        const data = await response.json();
        setFiles(data.files);
        setLoading(false);
    };

    const handleClick = async () => {
        const response = await fetch("https://hubdaive.com.br/api/auth/google-drive");
        const data = await response.json();
        window.location.href = data.auth_url;
    };

    console.log("loading:", loading, "connected:", connected, "files:", files.length);

    return(
        <>
    <style>{`
        .ripple {
            position: absolute;
            border: 2px solid #007AFF;
            opacity: 0;
            border-radius: 50%;
            width: 10px;
            height: 10px;
            animation: ripple-effect 3s linear infinite;
        }
        @keyframes ripple-effect {
            0% { width: 10px; height: 10px; opacity: 0.8; }
            100% { width: 250px; height: 250px; opacity: 0; border-width: 1px; }
        }
    `}</style>
        <div style={{
            position:'relative',
            minHeight: '100vh',
            maxWidth:'100vw',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'black', 
            fontFamily: 'Helvetica, Arial, sans-serif'
        }}>
            <img
                src={hubDaive}
                alt="logo"
                style={{ position: 'absolute', top: '3vh', left: '4vw', width: '10vw', height: 'auto' }} 
            />
            
            <div style={{
                position:'relative',
                height:'78vh',
                width: '78vw',
                backgroundColor:'#222',
                borderRadius:'10px',
                marginTop:'6vh'
            }}>
                {/* Cabeçalho */}
                <div style={{ 
                    padding: '15px 25px', 
                    borderBottom: '1px solid #222', 
                    display: 'flex', 
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '4vh', marginTop:'1vh', marginLeft:'1vw' }}>
                        Buscador de arquivos Drive
                    </span>
                    <GoogleButton onClick={handleClick} />
                </div>

                {/* Lista de arquivos */}
                <div style={{ 
                    overflowY: 'auto', 
                    height: '50vh', 
                    padding: '20px 25px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '15px',
                    alignContent: 'flex-start'
                }}>
                    {loading && (
                        <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        height: '100vh',
                        width: '100vw', 
                        backgroundColor: '#000', // Fundo escuro total
                        overflow: 'hidden'
                    }}>
                        {/* Container da Gota e Ondas */}
                        <div style={{ position: 'relative', width: '20vw', height: '20vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            
                            {/* A Gota Central */}
                            <div style={{
                                width: '1.5vw',
                                height: '1.5vw',
                                backgroundColor: '#007AFF', // Azul da gota
                                borderRadius: '50%',
                                zIndex: 2
                            }} />

                            {/* As Ondas (Ripples) */}
                            <div className="ripple" style={{ animationDelay: '0s' }}></div>
                            <div className="ripple" style={{ animationDelay: '1s' }}></div>
                            <div className="ripple" style={{ animationDelay: '2s' }}></div>
                        </div>

                        <h2 style={{ 
                            color: '#fff', 
                            marginTop: '40px', 
                            fontWeight: '300', 
                            fontFamily: 'Helvetica',
                            fontSize: '2.5vh',
                            letterSpacing: '2px',
                            opacity: 0.8
                        }}>
                            Indo às profundezas...
                        </h2>

                        <style>{`
                            .ripple {
                                position: absolute;
                                border: 1px solid #007AFF;
                                opacity: 0;
                                border-radius: 50%;
                                width: 10px;
                                height: 10px;
                                animation: ripple-effect 3s linear infinite;
                            }

                            @keyframes ripple-effect {
                                0% {
                                    width: 10px;
                                    height: 10px;
                                    opacity: 0.8;
                                    border-width: 0.1px;
                                }
                                80% {
                                    opacity: 0.3;
                                }
                                100% {
                                    transform: scale(50); 
                                    opacity: 0;
                                    border-width: 1.5px;;
                                }
                            }
                        `}</style>
                    </div>
                    )}
                    
                    {!loading && !connected && (
                        <div style={{ color: '#fff', textAlign: 'center', marginTop: '16%', fontSize: '2.5vh', opacity: 0.6, width: '100%' }}>
                            Conecte seu Google Drive para ver os arquivos
                        </div>
                    )}
                    {!loading && !searching && connected && (searchResults || files).map(file => (
                        <a 
                            key={file.id}
                            href={file.webViewLink} 
                            target="_blank" 
                            rel="noreferrer"
                            style={{ textDecoration: 'none' }}
                        >
                            <div style={{
                                width: '15vw',
                                height: '15vh',
                                backgroundColor: '#ffffff15',
                                border: '1px solid #ffffff22',
                                borderRadius: '10px',
                                padding: '1.4vh 1vw',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                cursor: 'pointer',
                                transition: '0.2s',
                            }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#ffffff30'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#ffffff15'}
                            >
                                <span style={{ fontSize: '3vh' }}>📄</span>
                                <div>
                                    <div style={{ 
                                        color: '#fff', 
                                        fontWeight: 'bold', 
                                        fontSize: '2.5vh',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    }}>
                                        {file.name}
                                    </div>
                                    <div style={{ 
                                        color: '#ffffff88', 
                                        fontSize: '1.6vh',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        marginTop: '4px'
                                    }}>
                                        📁 {file.path}
                                    </div>
                                    <div style={{ color: '#ffffff66', 
                                                  fontSize: '1.6vh', 
                                                  marginTop: '2px' }}>
                                        📅 {new Date(file.created).toLocaleDateString('pt-BR')}
                                    </div>
                                </div>
                            </div>
                        </a>
                    ))}

                    {searching && (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft:'12vw', marginTop:'14vh' }}>
                            <div style={{ position: 'relative', width: '50vw', height: '15vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <div style={{ width: '12px', height: '12px', backgroundColor: '#007AFF',borderRadius: '50%', zIndex: 2 }} />
                                <div className="ripple" style={{ animationDelay: '0s' }}></div>
                                <div className="ripple" style={{ animationDelay: '1s' }}></div>
                                <div className="ripple" style={{ animationDelay: '2s' }}></div>
                            </div>
                            <h2 style={{ color: '#fff', marginTop: '40px', fontWeight: '300', fontFamily: 'Helvetica', letterSpacing: '2px', opacity: 0.8 }}>
                                Procurando...
                            </h2>
                        </div>
                    )}
                {/* Input */}
                    <textarea
                        value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSearch();
                                }
                            }}
                        placeholder="Descreva o arquivo que você procura..."
                        rows={1}
                        style={{
                            position:'absolute',
                            bottom:'3%',
                            left:'2.5%',
                            width: '95%',
                            height: '5vh',
                            resize: 'none',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '12px',
                            padding: '1vh 1vw', 
                            lineHeight: '1.5',
                            fontSize: '1.8vh',
                            fontFamily: 'inherit',
                            color: 'black',
                            outline: 'none',
                            overflowWrap: 'anywhere', 
                            wordBreak: 'normal',
                            whiteSpace: 'pre-wrap',
                            overflowY: 'hidden',
                            boxSizing: 'border-box'
                        }}
                    />
                    </div>
            </div>
        </div>
    </>
    )
}

export default Drive;